import { render, staticRenderFns } from "./CreateCustomCertificate.vue?vue&type=template&id=8bf868a6&"
import script from "./CreateCustomCertificate.vue?vue&type=script&lang=ts&"
export * from "./CreateCustomCertificate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports